import TextFieldsIcon from '@mui/icons-material/TextFields';
import ImageIcon from '@mui/icons-material/Image';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import HeightIcon from '@mui/icons-material/Height';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import CodeIcon from '@mui/icons-material/Code';

// Icon per editor element type, shared by the palette and "Meine Elemente".
export const ELEMENT_TYPE_ICONS = {
  text: TextFieldsIcon,
  image: ImageIcon,
  button: SmartButtonIcon,
  spacer: HeightIcon,
  divider: HorizontalRuleIcon,
  html: CodeIcon,
};
